<app-page [inTutorial]="true">
  <trade-creator [inTutorial]="true" [tutorialBuy]="true"></trade-creator>
</app-page>
